export const getInitialState = (): any => ({
  predictionData: {},
  predictionStatusStatus: 0
});
